webpackJsonp([24],{

/***/ 1086:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1087);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4d7a9b6e", content, true, {});

/***/ }),

/***/ 1087:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".day-checkbox-container[data-v-64412866]{display:flex;align-items:center}.placement-time-row[data-v-64412866]{margin-top:.5em;margin-bottom:.5em}.day-checkbox-container .form-check-input[data-v-64412866]{margin-top:0}.day-checkbox-container>.form-check[data-v-64412866]{height:18px}.workday-label[data-v-64412866]{margin-top:0;font-weight:400;margin-bottom:.5em}.day-hours-selector-header[data-v-64412866]{margin-bottom:.5em}@media only screen and (min-width:768px){.note-container[data-v-64412866],.time-from-container[data-v-64412866],.time-off-container[data-v-64412866],.time-to-container[data-v-64412866],.total-hours-container[data-v-64412866]{padding-left:1em}.total-hours-container[data-v-64412866]{text-align:center}}.timepicker-from-container[data-v-64412866]{display:flex;align-items:center}.from-label[data-v-64412866]{margin-right:.5em}.timepicker-to-container[data-v-64412866]{display:flex;align-items:center}.to-label[data-v-64412866]{margin-right:.5em;margin-left:1.3em}.total-hours-container[data-v-64412866]{display:flex;align-items:center}.total-label[data-v-64412866]{margin-right:.5em}", ""]);

// exports


/***/ }),

/***/ 1088:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[(_vm.label)?_c('label',[_vm._v("\n    "+_vm._s(_vm.label)+"\n    "),(_vm.isRequired)?_c('span',{staticClass:"asterisk-mark"},[_vm._v("*")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.adminDescription && _vm.$store.getters.isAgent)?_c('div',{staticClass:"admin-description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.adminDescription)}})]):_vm._e(),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"day-hour-list"},_vm._l((_vm.normalizedListDays),function(workday,index){return _c('div',{key:index,staticClass:"row placement-time-row"},[_c('div',{staticClass:"day-checkbox-container col-md-3",class:_vm.colClass},[_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.listDayCheck[index]),expression:"listDayCheck[index]"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":'workday' + index},domProps:{"checked":Array.isArray(_vm.listDayCheck[index])?_vm._i(_vm.listDayCheck[index],null)>-1:(_vm.listDayCheck[index])},on:{"change":[function($event){var $$a=_vm.listDayCheck[index],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.listDayCheck, index, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.listDayCheck, index, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.listDayCheck, index, $$c)}},function($event){return _vm.handleDataChange()}]}})]),_vm._v(" "),_c('label',{staticClass:"workday-label non-search-label",attrs:{"for":'workday' + index}},[_vm._v("\n          "+_vm._s(workday)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"time-from-container col-md-4 col-sm-6",class:_vm.colClass},[(_vm.useTimePicker)?_c('div',{staticClass:"timepicker-from-container"},[_c('div',{staticClass:"from-label"},[_vm._v(_vm._s(_vm.fromLabel))]),_vm._v(" "),_c('TimePickerWithLabel',{attrs:{"classList":"","isDisabled":_vm.listDayCheck[index] !== true,"minutesInterval":_vm.minutesInterval,"is24HoursFormat":_vm.is24HoursFormat,"submitClicked":_vm.submitClicked},on:{"input":function($event){return _vm.handleDataChange()}},model:{value:(_vm.listFrom[index]),callback:function ($$v) {_vm.$set(_vm.listFrom, index, $$v)},expression:"listFrom[index]"}})],1):_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.listFrom[index]),expression:"listFrom[index]"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.listDayCheck[index] !== true,"submitClicked":_vm.submitClicked,"placeholder":_vm.fromLabel},domProps:{"value":(_vm.listFrom[index])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.listFrom, index, $event.target.value)},function($event){return _vm.handleDataChange()}]}}),_vm._v(" "),(
              _vm.submitClicked &&
              _vm.isRequired &&
              _vm.listDayCheck[index] &&
              !_vm.listFrom[index]
            )?_c('p',{staticClass:"required-message"},[_vm._v("\n            "+_vm._s(_vm.getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED"))+"\n          ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"time-to-container col-md-4 col-sm-6",class:_vm.colClass},[(_vm.useTimePicker)?_c('div',{staticClass:"timepicker-to-container"},[_c('div',{staticClass:"to-label"},[_vm._v(_vm._s(_vm.toLabel))]),_vm._v(" "),_c('TimePickerWithLabel',{attrs:{"classList":"","isDisabled":_vm.listDayCheck[index] !== true,"minutesInterval":_vm.minutesInterval,"is24HoursFormat":_vm.is24HoursFormat,"submitClicked":_vm.submitClicked},on:{"input":function($event){return _vm.handleDataChange()}},model:{value:(_vm.listTo[index]),callback:function ($$v) {_vm.$set(_vm.listTo, index, $$v)},expression:"listTo[index]"}})],1):_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.listTo[index]),expression:"listTo[index]"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.listDayCheck[index] !== true,"submitClicked":_vm.submitClicked,"placeholder":_vm.toLabel},domProps:{"value":(_vm.listTo[index])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.listTo, index, $event.target.value)},function($event){return _vm.handleDataChange()}]}}),_vm._v(" "),(
              _vm.submitClicked &&
              _vm.isRequired &&
              _vm.listDayCheck[index] &&
              !_vm.listTo[index]
            )?_c('p',{staticClass:"required-message"},[_vm._v("\n            "+_vm._s(_vm.getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED"))+"\n          ")]):_vm._e()])]),_vm._v(" "),(_vm.useTimePicker && !_vm.hasNote && !_vm.hasTimeOff)?_c('div',{staticClass:"total-hours-container",class:_vm.colClass},[(_vm.calculateTotalTime(index))?_c('div',{staticClass:"total-label"},[_vm._v("\n          "+_vm._s(_vm.totalLabel)+"\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"total-value"},[_vm._v("\n          "+_vm._s(_vm.calculateTotalTime(index))+"\n        ")])]):_vm._e(),_vm._v(" "),(_vm.hasTimeOff)?_c('div',{staticClass:"time-off-container",class:_vm.colClass},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.listTimeOff[index]),expression:"listTimeOff[index]"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.listDayCheck[index] !== true,"submitClicked":_vm.submitClicked,"placeholder":_vm.timeoffLabel},domProps:{"value":(_vm.listTimeOff[index])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.listTimeOff, index, $event.target.value)},function($event){return _vm.handleDataChange()}]}}),_vm._v(" "),(
            _vm.submitClicked &&
            _vm.isRequired &&
            _vm.listDayCheck[index] &&
            !_vm.listTimeOff[index]
          )?_c('p',{staticClass:"required-message"},[_vm._v("\n          "+_vm._s(_vm.getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED"))+"\n        ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.hasNote)?_c('div',{staticClass:"note-container",class:_vm.colClass},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.listNote[index]),expression:"listNote[index]"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.listDayCheck[index] !== true,"submitClicked":_vm.submitClicked,"placeholder":_vm.noteHeader},domProps:{"value":(_vm.listNote[index])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.listNote, index, $event.target.value)},function($event){return _vm.handleDataChange()}]}})]):_vm._e()])}),0),_vm._v(" "),(!_vm.listDayCheck.includes(true) && _vm.submitClicked && _vm.isRequired)?_c('p',{staticClass:"required-message"},[_vm._v("\n    "+_vm._s(_vm.getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED"))+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 912:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DayHoursInput_vue__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DayHoursInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DayHoursInput_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DayHoursInput_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DayHoursInput_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64412866_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DayHoursInput_vue__ = __webpack_require__(1088);
function injectStyle (ssrContext) {
  __webpack_require__(1086)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64412866"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DayHoursInput_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64412866_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DayHoursInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 967:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _separator = __webpack_require__(100);

var _TimePickerWithLabel = __webpack_require__(281);

var _TimePickerWithLabel2 = _interopRequireDefault(_TimePickerWithLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component is used to select working hours (from ... to ...) for each working day (From Monday to Friday)*/
exports.default = {
  name: "DayHoursInput",
  props: {
    /* Name of the date picker component, currently, which is unused*/
    name: String,
    // Label at the top of component
    label: String,
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // Input value, which is used for v-model
    value: Array,
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: true
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    // true if disable the timepicker
    listDays: [String, Array],
    // true if has time off input
    hasTimeOff: {
      type: Boolean,
      default: false
    },
    hasNote: {
      type: Boolean,
      default: false
    },
    customLabels: {
      type: [String, Array, Boolean]
    },
    useTimePicker: {
      type: Boolean,
      default: false
    },
    minutesInterval: {
      type: Number,
      default: 15
    },
    is24HoursFormat: {
      type: Boolean,
      default: false
    }
  },
  components: {
    TimePickerWithLabel: _TimePickerWithLabel2.default
  },
  data: function data() {
    return {
      listDayCheck: [],
      listFrom: [],
      listTo: [],
      listTimeOff: [],
      listNote: []
    };
  },
  created: function created() {
    this.initialzeData();
  },

  computed: {
    fromLabel: function fromLabel() {
      return this.normalizedCustomLabel[1] ? this.normalizedCustomLabel[1] : "From";
    },
    toLabel: function toLabel() {
      return this.normalizedCustomLabel[2] ? this.normalizedCustomLabel[2] : "To";
    },
    totalLabel: function totalLabel() {
      return this.normalizedCustomLabel[3] ? this.normalizedCustomLabel[3] : "Total";
    },
    timeoffLabel: function timeoffLabel() {
      return this.normalizedCustomLabel[3] ? this.normalizedCustomLabel[3] : "Daily time off";
    },
    colClass: function colClass() {
      if (this.hasNote) {
        if (this.hasTimeOff) {
          return "col-lg-custom-24";
        } else {
          return "col-lg-3";
        }
      } else {
        if (this.hasTimeOff) {
          return "col-lg-3";
        } else {
          if (this.useTimePicker) {
            // Show total time column
            return "col-lg-3";
          } else {
            return "col-lg-4";
          }
        }
      }
    },
    noteHeader: function noteHeader() {
      if (this.hasTimeOff) {
        if (this.normalizedCustomLabel[4]) {
          return this.normalizedCustomLabel[4];
        } else {
          return "Note";
        }
      } else {
        if (this.normalizedCustomLabel[3]) {
          return this.normalizedCustomLabel[3];
        } else {
          return "Note";
        }
      }
    },
    normalizedCustomLabel: function normalizedCustomLabel() {
      if (!this.customLabels) {
        return [];
      }
      if (Array.isArray(this.customLabels)) {
        return this.customLabels;
      }
      return this.customLabels.split("\n").map(function (option) {
        return option.trim();
      }).filter(function (option) {
        return option.length > 0;
      });
    },
    normalizedListDays: function normalizedListDays() {
      if (!this.listDays) {
        return [];
      }
      if (Array.isArray(this.listDays)) {
        return this.listDays;
      }
      return this.listDays.split("\n").map(function (option) {
        return option.trim();
      }).filter(function (option) {
        return option.length > 0;
      });
    }
  },
  methods: {
    initialzeData: function initialzeData() {
      this.listDayCheck = [];
      this.listFrom = [];
      this.listTo = [];
      this.listTimeOff = [];
      this.listNote = [];
      if (this.value == null || this.value.length === 0) {
        return;
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var val = _step.value;

          if (val == null || val === "") {
            this.listDayCheck.push(null);
            this.listFrom.push(null);
            this.listTo.push(null);
            this.listTimeOff.push(null);
            this.listNote.push(null);
          } else {
            this.listDayCheck.push(true);
            var fromToTokens = void 0;
            if (val.includes(_separator.TIME_FROM_TO_SEPARATOR)) {
              // New data is separated by tab (use with Textbox)
              fromToTokens = val.split(_separator.TIME_FROM_TO_SEPARATOR);
            } else {
              if (!this.useTimePicker) {
                // Old data is separated by comma (use with Timepicker)
                var mapReplacedValues = {
                  ":AM": " AM",
                  ":PM": " PM"
                };
                fromToTokens = this.replaceAllByMap(val, mapReplacedValues).split(",");
              }
              fromToTokens = val.split(",");
              // Only get first 2 items
              fromToTokens = fromToTokens.slice(0, 2);
            }
            // Parse from
            if (this.useTimePicker) {
              if (fromToTokens[0]) {
                this.listFrom.push(this.parseTime(fromToTokens[0]));
              } else {
                this.listFrom.push(null);
              }
            } else {
              var from = fromToTokens[0];
              if (from === "Unspecified Time") {
                from = "";
              }
              this.listFrom.push(from);
            }
            // Parse to
            if (this.useTimePicker) {
              if (fromToTokens[1]) {
                this.listTo.push(this.parseTime(fromToTokens[1]));
              } else {
                this.listTo.push(null);
              }
            } else {
              if (fromToTokens.length < 2) {
                this.listTo.push(null);
                continue;
              }
              var to = fromToTokens[1];
              if (to === "Unspecified Time") {
                to = "";
              }
              this.listTo.push(to);
            }
            if (this.hasTimeOff) {
              if (fromToTokens.length < 3) {
                this.listTimeOff.push(null);
                continue;
              }
              var timeOff = fromToTokens[2];
              if (timeOff === "Unspecified") {
                timeOff = "";
              }
              this.listTimeOff.push(timeOff);
            }
            if (this.hasNote) {
              var noteIndex = this.hasTimeOff ? 3 : 2;
              if (fromToTokens.length < noteIndex + 1) {
                this.listNote.push("");
                continue;
              }
              var note = fromToTokens[noteIndex];
              this.listNote.push(note);
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    handleDataChange: function handleDataChange() {
      var result = [];
      for (var index = 0; index < this.normalizedListDays.length; index++) {
        var dayCheck = this.listDayCheck[index];
        if (dayCheck !== true) {
          result.push("");
          continue;
        }
        var from = this.listFrom[index];
        var to = this.listTo[index];
        var fromTo = void 0;
        if (this.useTimePicker) {
          fromTo = this.convertTimeToString(from) + _separator.TIME_FROM_TO_SEPARATOR + this.convertTimeToString(to);
        } else {
          if (!from) {
            from = "Unspecified Time";
          }
          if (!to) {
            to = "Unspecified Time";
          }
          fromTo = from + _separator.TIME_FROM_TO_SEPARATOR + to;
        }
        if (this.hasTimeOff) {
          var hasTimeOff = this.listTimeOff[index];
          if (!hasTimeOff) {
            hasTimeOff = "Unspecified";
          }
          fromTo += _separator.TIME_FROM_TO_SEPARATOR + hasTimeOff;
        }
        if (this.hasNote) {
          var note = this.listNote[index];
          if (!note) {
            note = "";
          }
          fromTo += _separator.TIME_FROM_TO_SEPARATOR + note;
        }
        result.push(fromTo);
      }
      this.$emit("input", result);
    },
    calculateTotalTime: function calculateTotalTime(index) {
      var fromAMPM = this.listFrom[index];
      var toAMPM = this.listTo[index];
      if (fromAMPM == null || toAMPM == null) {
        return;
      }
      return this.calculateDiffTime(fromAMPM, toAMPM);
    },
    parseTime: function parseTime(timeString) {
      /* Parse time from String to Object
        Input: '00:11:AM
        Output: {hh: 00, mm: 11, A: AM}
      */
      var tokens = timeString.split(":");
      if (tokens.length != 3) {
        return null;
      } else {
        return { hh: tokens[0], mm: tokens[1], A: tokens[2] };
      }
    },
    convertTimeToString: function convertTimeToString(time) {
      /* Convert time from Object to String
        Input: {hh: 00, mm: 11, A: AM}
        Output: '00:11:AM
      */
      if (time == null) {
        return "";
      }
      return time.hh + ":" + time.mm + ":" + time.A;
    }
  }
};

/***/ })

});


// WEBPACK FOOTER //
// 24.build.js